import VisibleComponent from '../VisibleComponent'
import './index.less'

const template = `
    <div class="mtg-mask"></div>
`

/**
 * 遮罩类
 * @constructor
 * @extends VisibleComponent
 * @param options 构造参数
 */
class Mask extends VisibleComponent {
    constructor (options={}) {
        super(options)

        this.template = template
        this.init(options)
    }

    init(options){
        super.init(options)
        const {
            opacity
        } = options

        opacity && (this.element.style.backgroundColor = `rgba(0,0,0,${opacity})` )
    }
}

export default Mask